export class OrgService {

    service_id: number;
    service_type: string;
    service_name: string;
    service_description: string;
    service_quantity: string;
    service_cost: string;
    org_code: string;
}
